export default __webpack_public_path__ + "static/media/onyx-master-plan.dc2f22a8.webp";